import React from 'react';
import { Button, StackView } from '@telus-uds/components-web';
import PropTypes, { array } from 'prop-types';
import { addLocale, getLocalizedStrings } from '../misc';
import { useLocaleContext } from '../context/LocaleContext';
import { useHistory } from 'react-router-dom';
// Box migrated to UDS
import { HelpSectionContainer,
  HelpSectionMain,
  HelpSectionTopBar,
  HelpSectionCloseButton,
  HelpBottomSection} from './styles';
const Help = ({ setShowHelpSection }) => {
  const {
    helpBar: { howToVideos, businessConnect, businessApps, internetOfThings }
  } = getLocalizedStrings();

  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);
 const history = useHistory()
  const onVideosClick = () => {
    history.push(addLocaleToUrl('/how-to-videos'));
    window.location.reload()
  };

  const onBusinessConnectClick = () => {
    window.open(
      'http://assets.ctfassets.net/q1vokyi3iq1f/A4waVylzIyj26aLwImVOr/c14a9fcd30aee8d2b9d1016bd05dda13/user_guide.pdf'
    );
  };

  const onBusinessAppsClick = () => {
    if (locale === 'fr-CA')
      window.open(
        'https://assets.ctfassets.net/q1vokyi3iq1f/4566qnrCXfHEtlI95IRJK2/66b3ebc823dfc6b69217ecf7c403d9fa/MySOF_Job_Aid_-_BizApps_Sales__FR_.pdf'
      );
    else
      window.open(
        'https://assets.ctfassets.net/q1vokyi3iq1f/7D5hgWrRuXWPBaeBA6RapH/50e531bb15f5cca06e64de8a974399ec/MySOF_Job_Aid_-_BizApps_Sales.pdf'
      );
  };

  const onInternetOfThingsClick = () => {
    if (locale === 'fr-CA')
      window.open(
        'https://assets.ctfassets.net/q1vokyi3iq1f/1b1usNRFicpYvGoiNM19L9/cfc809715db2f897b70e16713e25282c/MySOF_Job_Aid_-_IOT_Sales_FR.pdf'
      );
    else
      window.open(
        'https://assets.ctfassets.net/q1vokyi3iq1f/7s1v8qHSezb50racWkRrxy/6062530ccb077e418410f02fde905376/MySOF_Job_Aid_-_IOT_Sales.pdf'
      );
  };

  return (
    <HelpSectionContainer>
    <HelpSectionMain $isFrench={locale === 'fr-CA'}>
      <HelpSectionTopBar>
        <HelpSectionCloseButton onClick={() => setShowHelpSection(false)}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            data-testid="dependentSvg"
            color="white"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M12 12.707l-4.147 4.146a.498.498 0 0 1-.707 0 .5.5 0 0 1 0-.707L11.293 12 7.146 7.853a.5.5 0 0 1 .707-.707L12 11.293l4.146-4.147a.5.5 0 0 1 .707.707L12.707 12l4.146 4.146a.5.5 0 0 1-.707.707L12 12.707zM12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.957C5.958 1.043 1.043 5.958 1.043 12c0 6.042 4.915 10.957 10.957 10.957 6.042 0 10.957-4.915 10.957-10.957 0-6.042-4.915-10.957-10.957-10.957z"
              fill="#fff"
            ></path>
          </svg>
        </HelpSectionCloseButton>
      </HelpSectionTopBar>
      <HelpBottomSection>
        <StackView space={3}>
        <center>
        <Button variant={{ priority: 'high' }} style={{width:"84%"}}
            type="button"
            onClick={onVideosClick}>
            {howToVideos}
          </Button>
          <br />
          <br />
          <Button variant={{ priority: 'high' }} style={{width:"100%" , padding:"0px"}}
            type="button"
            onClick={onBusinessConnectClick}>
            {businessConnect}
          </Button>
          <br />
          <br />
          <Button variant={{ priority: 'high' }} style={{width:"100%" , padding:"0px"}}
            type="button"
            onClick={onBusinessAppsClick}>
            {businessApps}
          </Button>
          <br />
          <br />
          <Button variant={{ priority: 'high' }} style={{width:"100%" , padding:"0px"}}
            type="button"
            onClick={onInternetOfThingsClick}>
            {internetOfThings}
          </Button>
        </center>
        </StackView>
      </HelpBottomSection>
    </HelpSectionMain>
  </HelpSectionContainer>
  );
};

Help.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func
  }).isRequired
};

export default Help;
